import { TableCell } from '@mui/material';
import { withStyles } from '@mui/styles';
import React from 'react';
import Box from '@mui/material/Box';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledCell = withStyles({
  root: {
    position: 'relative',
    minWidth: ({ cellwidth }) => `${cellwidth}`,
    width: ({ cellwidth }) => `${cellwidth}`,
    maxWidth: ({ cellwidth }) => `${cellwidth}`,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: ({ bold }) => (bold ? '600' : 'normal'),
    color: ({ bold }) => (bold ? '#232629 !important' : 'inherit'),

    '&.MuiTableCell-root.MuiTableCell-root.MuiTableCell-body': {
      whiteSpace: 'nowrap',
    },

    '& .switchButton': {
      display: 'none',
      height: '32px',
    },
  },
})(TableCell);

const StyledMethodIcon = withStyles({
  root: {
    '& svg': {
      height: '16px',
    },
  },
})(Box);

const OverFlowHiddenContainer = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;

  p {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const StyledTableCell = ({ align, column, children, id, bold, customWidth }) => {
  const width = `${customWidth ?? column?.width ?? 150}px`;
  return (
    <StyledCell cellwidth={width} id={id} overflow="hidden" align={align} bgcolor="#fff" bold={bold ? 1 : 0}>
      {children}
    </StyledCell>
  );
};
StyledTableCell.propTypes = {
  align: PropTypes.string,
  column: PropTypes.shape({
    width: PropTypes.number,
  }),
  id: PropTypes.string.isRequired,
  bold: PropTypes.bool,
  customWidth: PropTypes.number,
};
StyledTableCell.defaultProps = {
  align: 'left',
  column: {
    width: 150,
  },
  bold: false,
  customWidth: null,
};

export { StyledTableCell, StyledMethodIcon, OverFlowHiddenContainer };
